import { render, staticRenderFns } from "./DollarAmount.vue?vue&type=template&id=401de397&"
import script from "./DollarAmount.vue?vue&type=script&lang=js&"
export * from "./DollarAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports